import ManagedLookup from '../components/ManagedLookup';
import fields from './fields';
import useLookupPage from '../hooks/useLookupPage';
import columns from './columns';
import useUomReferences from './useUomReferences';

const UnitsOfMeasurement = ({ definition }) => {
    const page = useLookupPage('units-of-measurement', columns);
    const references = useUomReferences(page.rows);
    return <ManagedLookup definition={definition} columns={columns} fields={fields}
        page={{ ...page, rows: references.rows, loading: page.loading || references.loading }} />;
};

export default UnitsOfMeasurement;
